<template>
    <div class="o-form__item" v-if="!$apollo.queries.shiftTemplates.loading && shiftTemplates.length>0"
        :data-component-name="$options.name"
    >
        <q-btn-dropdown
            rounded
            split
            color="blue"
            label="Nouveau quart de travail"
            @click.stop="newShiftFromTemplate(newProjectShift)"
            size="sm"
            no-caps
        >
        <q-list>
            <q-item
                clickable
                v-close-popup
                @click="newShiftFromTemplate(shiftTemplate)"
                v-bind:key="shiftTemplate.shiftTemplateID"
                v-for="shiftTemplate in shiftTemplates"
                style="min-width:150px; text-align: right"
            >
                <q-item-section>
                    <div class="c-project-shift__name"><q-item-label>{{shiftTemplate.name}}</q-item-label></div>
                    <div class="c-project-shift__desc"><q-item-label caption v-if="shiftTemplate.description!=''">{{ shiftTemplate.description }}</q-item-label></div>
                </q-item-section>
            </q-item>
        </q-list>
        </q-btn-dropdown>
    </div>
    <div class="o-form__item" v-else>
        <q-btn
            split
            color="blue"
            label="Nouveau quart de travail"
            @click.stop="newShiftFromTemplate(newProjectShift)"
            size="sm"
            no-caps
        />
    </div>
</template>

<script>
    import { SHIFTTEMPLATES } from '@/graphql/shift/queries'
    import {getWeeksLimits} from '@/js/dateUtilities'
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: "ShiftTemplatesList",
        props: {
            weekrange:{
                type: Object,
                default(){
                    let date=getWeeksLimits(new Date(), this.$generalSettings.settings.firstDayOfWeek);
                    return {
                        ...date
                    }
                }
            }
        },
        apollo: {
            shiftTemplates: {
                query: SHIFTTEMPLATES,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(shiftTemplates) {
                    shiftTemplates.shiftTemplates.data.forEach(function(item){
                        item.projectAssignments=[];
                        item.dates=[
                                // {
                                //     from: this.weekrange.str.from,
                                //     to: this.weekrange.str.to
                                // }
                        ];
                        item.courses=[];
                        item.skills=[];
                        item.customtags=[];
                        item.resources=[];
                        item.staffVehicules=[];
                        item.opened=true;
                        item.isNew=true;
                    }.bind(this))
                    return shiftTemplates.shiftTemplates.data;
                }
            },
        },
        data(){
            return {
                newProjectShift: {
                    Sun: false,
                    Mon: true,
                    Tue: true,
                    Wed: true,
                    Thu: true,
                    Fri: true,
                    Sat: false,
                    dates:[
                        // {
                        //     from: this.weekrange.str.from,
                        //     to: this.weekrange.str.to
                        // }
                    ],
                    name: 'Nouveau quart de travail',
                    projectAssignments:[],
                    courses:[],
                    skills:[],
                    customtags: [],
                    resources: [],
                    staffVehicules: [],
                    opened: true,
                    isNew: true
                }
            }
        },
        mounted(){
        },
        methods:{
            newShiftFromTemplate(item){
                let newItem=JSON.parse(JSON.stringify(item));
                newItem.id='newProjectShift-' + uuidv4();
                // newItem.id='newProjectShift';
                this.$emit('set-new-shift', newItem);
            }
        }

    }
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        background: white;
        position: absolute;
        z-index: 11;
        right: 0;
        border: 1px solid gray;
        min-width: 200px;
        li {
            padding: 6px;
            text-align: right;
            &.list-item:hover {
                background: gray;
                cursor: pointer;
                color: white;
            }
        }
    }
</style>
